import React, { useEffect, useState, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SessionExpiredModal from "./SessionExpiredModal";
import { attachSessionListeners, clearSessionExpiredFlag } from "../utils/sessionBus";
import { startTokenWatcher, stopTokenWatcher } from "../utils/tokenWatcher";

export default function GlobalSessionUI() {
  const [expired, setExpired] = useState(false);
  const location = useLocation();

  // Listen for the global "session expiration" event
  useEffect(() => attachSessionListeners(() => setExpired(true)), []);

  // token change/expiration monitoring
  useEffect(() => {
    const stop = startTokenWatcher();
    return () => { stop?.(); stopTokenWatcher(); };
  }, []);

  // When entering the authentication route (login/registration/forgot password) : forcibly close the pop-up window and clear the tag
  useEffect(() => {
    const authPaths = ["/", "/login", "/signup", "/forgot-password"];
    if (authPaths.includes(location.pathname)) {
      clearSessionExpiredFlag();
      window.__SESSION_EXPIRED_SHOWN__ = false;
      setExpired(false);
    }
  }, [location.pathname]);

  const handleGoLogin = useCallback(() => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    } finally {
      window.__SESSION_EXPIRED_SHOWN__ = false;
      clearSessionExpiredFlag();
      setExpired(false);
      window.location.replace("/"); 
    }
  }, []);

  return (
    <>
      <Outlet />
      <SessionExpiredModal open={expired} onConfirm={handleGoLogin} />
    </>
  );
}
